<template>
  <div class="home">
    <div class="d-flex justify-space-between">
      <div class="headline ml-2 mb-4">
        Participants ({{ studyNameFilter ? studyNameFilter : "All Studies" }})
      </div>
      <v-btn
        text
        color="primary"
        @click="iconsLegendSnackbar = true"
        :disabled="iconsLegendSnackbar"
        >Show legend</v-btn
      >
    </div>
    <v-card>
      <v-tabs v-model="tableTabs" centered background-color="primary" dark>
        <v-tab href="#table-tab-1">
          Ongoing Studies
        </v-tab>
        <v-tab href="#table-tab-2">
          Completed Studies
        </v-tab>
        <v-tab href="#table-tab-3">
          Other
        </v-tab>
      </v-tabs>
    </v-card>

    <v-tabs-items v-model="tableTabs">
      <v-tab-item value="table-tab-1">
        <md-table
          :value="studiesOngoing"
          md-sort="needsReview"
          md-sort-order="desc"
        >
          <home-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            :item="item"
            :pastWeekStart="encodedPastWeekStart"
          />
        </md-table>
      </v-tab-item>
      <v-tab-item value="table-tab-2">
        <md-table
          :value="studiesCompleted"
          md-sort="needsReview"
          md-sort-order="desc"
          v-if="completedStudiesTableLoaded"
        >
          <home-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            :item="item"
            :pastWeekStart="encodedPastWeekStart"
          />
        </md-table>
      </v-tab-item>
      <v-tab-item value="table-tab-3">
        <md-table
          :value="studiesOther"
          md-sort="needsReview"
          md-sort-order="desc"
          v-if="otherStudiesTableLoaded"
        >
          <home-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            :item="item"
            :pastWeekStart="encodedPastWeekStart"
          />
        </md-table>
      </v-tab-item>
    </v-tabs-items>

    <v-snackbar
      v-model="iconsLegendSnackbar"
      bottom
      right
      multi-line
      color="#2f3570"
      class="legend-snackbar"
      :timeout="300000"
    >
      <div>
        <div class="title mb-2">Legend</div>
        <div class="body-2 my-1">
          <v-icon dark>edit</v-icon> Parameters last updated by user
        </div>
        <div class="body-2 my-1">
          <v-icon dark>check</v-icon> Parameters acknowledged
        </div>
        <div class="body-2 my-1">
          <v-icon dark>hourglass_empty</v-icon> Parameters not acknowledged yet
        </div>
        <div class="body-2 my-1">
          <v-icon dark>flag</v-icon> Parameters flagged during review
        </div>
        <v-divider dark class="my-2" />
        <div class="body-2 my-1">
          <v-icon color="warning">warning</v-icon> Insufficient data:
          notification sent
        </div>
        <div class="body-2 my-1">
          <v-icon color="error">warning</v-icon> Insufficient data: error
          sending the notification
        </div>
        <v-divider dark class="my-2" />
        <div class="body-2 my-1">
          <v-icon color="info">drafts</v-icon> Patient has opened the survey
          link
        </div>
        <div class="body-2 my-1">
          <v-icon color="error">mail</v-icon> Survey link has been sent but not
          opened yet
        </div>
      </div>
      <v-btn dark icon text @click="iconsLegendSnackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<style scoped>
.home {
  text-align: left;
  margin-bottom: 50px;
}

.md-dialog-content {
  padding-top: 0px !important;
}
.assignedUser {
  font-weight: bold;
  border-left: 10px solid #448aff;
}

.home-table-row {
  cursor: pointer;
}

.row-for-review {
  border-left: 10px solid #ff5252;
}

.legend-snackbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>

<script>
import HomeTableRow from "../components/HomeTableRow";

import { mapState } from "vuex";
import { encodeGraphDataKey } from "../globals";

export default {
  name: "home",
  components: {
    HomeTableRow
  },
  data: () => ({
    iconsLegendSnackbar: false,
    tableTabs: null,
    completedStudiesTableLoaded: false,
    otherStudiesTableLoaded: false,
    studiesOngoing: null,
    studiesCompleted: null,
    studiesOther: null
  }),
  computed: {
    ...mapState([
      "dbStudies",
      "dbAdminUsers",
      "dbAdminParamsToReview",
      "adminUser",
      "pastWeekStart",
      "studyNameFilter"
    ]),
    encodedPastWeekStart: function() {
      return encodeGraphDataKey(this.pastWeekStart);
    }
  },
  watch: {
    tableTabs: function(val) {
      if (val === "table-tab-2" && !this.completedStudiesTableLoaded) {
        this.completedStudiesTableLoaded = true;
      } else if (val === "table-tab-3" && !this.otherStudiesTableLoaded) {
        this.otherStudiesTableLoaded = true;
      }
    },
    dbStudies: function() {
      this.updateStudiesFilters();
    }
  },
  mounted() {
    this.updateStudiesFilters();
  },
  methods: {
    openUserStudy(uid) {
      this.$router.push({ path: `/user/${uid}` });
    },
    updateStudiesFilters() {
      this.studiesOngoing = this.dbStudies.filter(
        study => study.studyStatus && study.studyStatus === "ongoing"
      );

      this.studiesCompleted = this.dbStudies.filter(
        study => study.studyStatus && study.studyStatus === "completed"
      );

      this.studiesOther = this.dbStudies.filter(
        study =>
          !study.studyStatus ||
          (study.studyStatus !== "ongoing" && study.studyStatus !== "completed")
      );
    }
  }
};
</script>
